import React from 'react'
import GridContainer from '../../../../../Grid/GridContainer'
import GridItem from '../../../../../Grid/GridItem'
import { useTranslation } from 'react-i18next'
import { EditTransferServiceFooterProps } from './interfaces'
import ButtonSpinner from '../../../../../ButtonSpinner'
import { Color } from '../../../../../../util'

export const EditTransferServiceFooter = ({
  canAssignDriver,
  openDrivers,
  saveService,
}: EditTransferServiceFooterProps) => {
  const { t } = useTranslation()

  return (
    <GridContainer className="button-translado" align-content={'flex-end'} alignItems="">
      {canAssignDriver && (
        <GridItem xs={5} sm={5} md={5}>
          <ButtonSpinner
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => openDrivers(e)}
            color={Color.secondary}
            label={t('service.driver.assign')}
          />          
        </GridItem>
      )}
      <GridItem xs={5} sm={5} md={5}>
        <ButtonSpinner
          color={Color.primary}
          onClick={saveService}
          label={t('service.save')}
        />
      </GridItem>
    </GridContainer>
  )
}
